export default {
    statistics: {
        title: 'Mood Statistics',
        select: {
            business: 'Business',
            department: 'Departments'
        },
        periods: [
            {
                label: 'Current Week',
                value: 'week'
            },
            {
                label: 'Current Month',
                value: 'month'
            },
            {
                label: 'Current Year',
                value: 'year'
            },
            {
                label: 'Custom Date Range',
                value: 'range'
            }
        ],
        periodsMember: [
            {
                title: 'Lifetime',
                value: 'lifetime'
            },
            {
                title: 'Current Week',
                value: 'week'
            },
            {
                title: 'Current Month',
                value: 'month'
            },
            {
                title: 'Current Year',
                value: 'year'
            },
            {
                title: 'Custom Date Range',
                value: 'range'
            }
        ],
        weekDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sept',
            'Oct',
            'Nov',
            'Dec'
        ],
        moodLabels: [
            'COMPLETELY CHILL',
            'CONTENT',
            'SOMEWHERE IN BETWEEN',
            'ANXIOUS',
            'SUPER STRESSED'
        ],
        widgets: {
            meditations: {
                icon: 'schedule',
                description: 'Minutes Practiced',
                descriptionHours: 'Hours Practiced',
                tooltip:
                    'Total number of minutes meditated in the selected time period'
            },
            liveMeditations: {
                icon: 'wifi_tethering',
                description: 'Live Minutes Practiced',
                descriptionHours: 'Live Hours Practiced',
                tooltip: 'Minutes practiced in live stream sessions'
            },
            recordedMeditations: {
                icon: 'videocam',
                description: 'Minutes Practiced',
                descriptionHours: 'Hours Practiced',
                tooltip: 'Minutes practiced in recorded sessions'
            },
            membersMeditated: {
                icon: 'supervisor_account',
                description: 'Members Practiced',
                descriptionHours: 'Members Practiced',
                tooltip: 'Members Practiced'
            },
            completedMeditations: {
                icon: 'star',
                description: 'Total Practices',
                tooltip:
                    'Sessions viewed, where members logged their mood before and after'
            },
            userMeditated: {
                icon: 'schedule',
                description: 'Minutes Practiced',
                descriptionHours: 'Hours Practiced',
                tooltip:
                    'Total number of minutes practiced in the selected time period'
            },
            userViewed: {
                icon: 'videocam',
                description: 'Sessions Viewed',
                tooltip: 'Live and recorded sessions opened'
            },
            userCompleted: {
                icon: 'star',
                description: 'Successfully Completed',
                tooltip: 'Sessions viewed, with mood logged before and after'
            },
            uniqueUsers: {
                icon: 'perm_identity',
                description: 'Unique Members',
                tooltip: 'Unique Members'
            },
            consecutiveDays: {
                icon: 'track_changes',
                description: 'Consecutive Days Meditated',
                tooltip: 'Number of days meditated in a row'
            }
        }
    }
};
